import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import SearchBox from "../Common/SearchBox";
import AppNavigator from "../Common/AppNavigator";
import { HeadBackIcon, SideArrow, SideBar, SignOutIcon } from "../../Assets/Icons";
import { removeUserData } from "../../store/slice/userSlice";
import { defaultLogo } from "../../env";
import { useNavigate, useParams } from "react-router-dom";
import { SearchContext } from "../../store/context/searchContext";
import jwtEncode from "jwt-encode";
import { handleLogin } from "../../utils/common";

const Header = ({ setMobileShowSideBar, mobileShowSideBar, parentCategory, handleDebounceBackClick, showSearch }) => {
  const params = useParams();
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const { search, setSearch } = useContext(SearchContext);
  const [inputValue, setInputValue] = useState(search);
  const { id } = params;

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(inputValue);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  const handleUserLogOut = async () => {
    try {
      await axios.post(
        `${configData?.config.UNO_URL}/api/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(removeUserData());
      handleLogin(configData.config.redirectUri, jwtEncode);
    }
  };

  const handleHideMobileSideBar = () => {
    document.body.classList.add("active-sidebar");
    setMobileShowSideBar(true);
  };

  const handleHeaderLogoClick = async () => {
    console.log("Click");
    if (userData.token) {
      navigate("/");
    } else {
      handleUserLogOut();
    }
  };

  const placeholderUserName = userData?.user?.name
    ?.split(" ")
    .slice(0, 2)
    .map((e) => e.charAt(0).toUpperCase())
    .join("");

  return (
    <>
      {/* For Landscape */}
      <header className="main-head">
        <div className="left">
          <span className="logo" onClick={handleHeaderLogoClick}>
            <img src={configData?.config?.logo || defaultLogo} referrerPolicy={"no-referrer"} />
            <p>{configData?.config?.name}</p>
          </span>
        </div>

        {userData.token ? (
          <div className="right ">
            {showSearch && <SearchBox />}
            <div className="dropdown">
              <div className="profile-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                {userData?.user?.avatar ? (
                  <img src={userData?.user?.avatar} referrerPolicy={"no-referrer"} />
                ) : (
                  <span className="placeholder-"> {placeholderUserName} </span>
                )}

                <span className="name-email">
                  <h6>{userData?.user?.name}</h6>
                  <p>{userData?.user?.designation}</p>
                </span>
              </div>
              <div className="dropdown-menu profile-detail-parent p-0">
                <div className="profile-detail">
                  <div className="bg">
                    {userData?.user?.avatar ? (
                      <img src={userData?.user?.avatar} referrerPolicy={"no-referrer"} />
                    ) : (
                      <span> {placeholderUserName} </span>
                    )}
                  </div>
                  <span className="name-email">
                    <p>{userData?.user?.name}</p>
                    <p>{userData?.user?.email}</p>
                  </span>
                  <span className="signout" onClick={handleUserLogOut}>
                    <SignOutIcon />
                    Sign Out
                  </span>
                </div>
              </div>
            </div>
            <AppNavigator />
          </div>
        ) : (
          <>
            <button className="loginBtn" onClick={handleHeaderLogoClick}>
              Login
            </button>
          </>
        )}
      </header>

      {/* For Portrait */}
      <header className="main-head mobile">
        <div className="search-n-nav">
          <div className="search-profile">
            <span className="side-btn" onClick={handleHideMobileSideBar}>
              <SideBar />
            </span>
            <span className="profile-icon" onClick={handleHideMobileSideBar}>
              {userData?.user?.avatar ? (
                <img src={userData?.user?.avatar} referrerPolicy={"no-referrer"} />
              ) : (
                <span className="placeholder-"> {placeholderUserName} </span>
              )}
            </span>

            <input
              type="text"
              className="form-control"
              placeholder="Search 3D Models"
              autoComplete="off"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>
          <span className="mobile-navigator">
            <AppNavigator />
          </span>
        </div>
        {id && (
          <div className="current-place">
            {(id != configData.config["3dAssetsId"] || id != parentCategory.id) && (
              <span onClick={handleDebounceBackClick}>
                {" "}
                <HeadBackIcon />{" "}
              </span>
            )}
            {parentCategory?.name || "All Category"}
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
